import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import getData from "../reducer";
const reducer = combineReducers({
  getData,
});
export const store = createStore(reducer, applyMiddleware(thunk));
